import { learnSeoPages } from "../content/learnPages";

// Páginas de Aprender que el jugador todavía no ha abierto (para la bolita del menú).
export const LEARN_SEEN_EVENT = "xima:learn-seen";
const storageKey = (userKey) => `xima_learn_seen_pages_v1_${String(userKey || "guest").toLowerCase()}`;

const readSeen = (userKey) => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey(userKey)) || "[]");
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch (error) {
    return new Set();
  }
};

export const markLearnPageSeen = (userKey, slug) => {
  const normalizedSlug = String(slug || "").trim().toLowerCase();
  if (!normalizedSlug || typeof window === "undefined") return;
  const seen = readSeen(userKey);
  if (seen.has(normalizedSlug)) return;
  seen.add(normalizedSlug);
  try {
    window.localStorage.setItem(storageKey(userKey), JSON.stringify([...seen]));
  } catch (error) {
    // Without storage the count simply stays as it is.
  }
  window.dispatchEvent(new CustomEvent(LEARN_SEEN_EVENT));
};

export const countUnseenLearnPages = (userKey) => {
  if (typeof window === "undefined") return 0;
  const seen = readSeen(userKey);
  const slugs = new Set(
    learnSeoPages.map((page) => String(page?.slug || "").trim().toLowerCase()).filter(Boolean)
  );
  let unseen = 0;
  slugs.forEach((slug) => {
    if (!seen.has(slug)) unseen += 1;
  });
  return unseen;
};
